import { render, staticRenderFns } from "./addDishtype.vue?vue&type=template&id=51839bae&scoped=true&"
import script from "./addDishtype.vue?vue&type=script&lang=ts&"
export * from "./addDishtype.vue?vue&type=script&lang=ts&"
import style0 from "./addDishtype.vue?vue&type=style&index=0&id=51839bae&lang=scss&scoped=true&"
import style1 from "./addDishtype.vue?vue&type=style&index=1&id=51839bae&lang=scss&scoped=true&"
import style2 from "./addDishtype.vue?vue&type=style&index=2&id=51839bae&lang=scss&scoped=true&"
import style3 from "./addDishtype.vue?vue&type=style&index=3&id=51839bae&lang=scss&scoped=true&"
import style4 from "./addDishtype.vue?vue&type=style&index=4&id=51839bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51839bae",
  null
  
)

export default component.exports